export const CLASS_TRIAL_STATUS_OPTIONS = [
  "ลูกค้ากรอกฟอร์มแล้ว รอ OP หาครู",
  "OP กำลังหาครู",
  "OP หาครูได้แล้ว รอ Sales ไป CF กับผู้ปกครอง",
  "ลูกค้า CF แล้ว รอ OP จัดตารางเรียน",
  "OP จัดตารางทดลองเรียนแล้ว",
  "กำลังทดลองเรียน",
  "ครูส่งผลประเมินแล้ว",
  "Sales ติดตามลูกค้า",
  "Sales ติดตามลูกค้า (ครั้งที่2)",
  "Sales ติดตามลูกค้า (ครั้งที่3)",
  "รอลูกค้าตัดสินใจ",
  "ปิดการขายเรียบร้อย",
  "ยกเลิกการทดลองเรียน",
  "ปิดการขายไม่สำเร็จ",
  "ทดลองแล้วลูกค้าไม่สนใจ",
  "ยกเลิกทดลองเรียนแต่ให้ครู",
  "ลูกค้าไม่สนใจ (รอปรึกษาและตัดจากที่กัพ)",
];

export function getTrialStatusColor(status: string): string {
  switch (status) {
    case "ลูกค้ากรอกฟอร์มแล้ว รอ OP หาครู":
      return "bg-slate-100 text-slate-800 border-slate-200 dark:bg-slate-900 dark:text-slate-200 dark:border-slate-800";
    case "OP กำลังหาครู":
      return "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900 dark:text-amber-200 dark:border-amber-800";
    case "OP หาครูได้แล้ว รอ Sales ไป CF กับผู้ปกครอง":
      return "bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900 dark:text-yellow-200 dark:border-yellow-800";
    case "ลูกค้า CF แล้ว รอ OP จัดตารางเรียน":
      return "bg-cyan-100 text-cyan-800 border-cyan-200 dark:bg-cyan-900 dark:text-cyan-200 dark:border-cyan-800";
    case "OP จัดตารางทดลองเรียนแล้ว":
      return "bg-teal-100 text-teal-800 border-teal-200 dark:bg-teal-900 dark:text-teal-200 dark:border-teal-800";
    case "กำลังทดลองเรียน":
      return "bg-indigo-100 text-indigo-800 border-indigo-200 dark:bg-indigo-900 dark:text-indigo-200 dark:border-indigo-800";
    case "ครูส่งผลประเมินแล้ว":
      return "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900 dark:text-blue-200 dark:border-blue-800";
    case "Sales ติดตามลูกค้า":
      return "bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900 dark:text-orange-200 dark:border-orange-800";
    case "Sales ติดตามลูกค้า (ครั้งที่2)":
      return "bg-orange-200 text-orange-900 border-orange-300 dark:bg-orange-800 dark:text-orange-100 dark:border-orange-700";
    case "Sales ติดตามลูกค้า (ครั้งที่3)":
      return "bg-orange-300 text-orange-950 border-orange-400 dark:bg-orange-700 dark:text-orange-50 dark:border-orange-600";
    case "รอลูกค้าตัดสินใจ":
      return "bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900 dark:text-yellow-200 dark:border-yellow-800";
    case "ปิดการขายเรียบร้อย":
      return "bg-green-100 text-green-800 border-green-200 dark:bg-green-900 dark:text-green-200 dark:border-green-800";
    case "ยกเลิกการทดลองเรียน":
      return "bg-pink-100 text-pink-800 border-pink-200 dark:bg-pink-900 dark:text-pink-200 dark:border-pink-800";
    case "ปิดการขายไม่สำเร็จ":
      return "bg-red-100 text-red-800 border-red-200 dark:bg-red-900 dark:text-red-200 dark:border-red-800";
    case "ทดลองแล้วลูกค้าไม่สนใจ":
      return "bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-800";
    case "ยกเลิกทดลองเรียนแต่ให้ครู":
      return "bg-purple-100 text-purple-800 border-purple-200 dark:bg-purple-900 dark:text-purple-200 dark:border-purple-800";
    case "ลูกค้าไม่สนใจ (รอปรึกษาและตัดจากที่กัพ)":
      return "bg-stone-100 text-stone-800 border-stone-200 dark:bg-stone-900 dark:text-stone-200 dark:border-stone-800";
    default:
      return "bg-muted text-muted-foreground";
  }
}

export function getTrialStatusColumnColor(status: string): string {
  switch (status) {
    case "ลูกค้ากรอกฟอร์มแล้ว รอ OP หาครู":
      return "border-t-slate-500";
    case "OP กำลังหาครู":
      return "border-t-amber-500";
    case "OP หาครูได้แล้ว รอ Sales ไป CF กับผู้ปกครอง":
      return "border-t-yellow-500";
    case "ลูกค้า CF แล้ว รอ OP จัดตารางเรียน":
      return "border-t-cyan-500";
    case "OP จัดตารางทดลองเรียนแล้ว":
      return "border-t-teal-500";
    case "กำลังทดลองเรียน":
      return "border-t-indigo-500";
    case "ครูส่งผลประเมินแล้ว":
      return "border-t-blue-500";
    case "Sales ติดตามลูกค้า":
      return "border-t-orange-500";
    case "Sales ติดตามลูกค้า (ครั้งที่2)":
      return "border-t-orange-600";
    case "Sales ติดตามลูกค้า (ครั้งที่3)":
      return "border-t-orange-700";
    case "รอลูกค้าตัดสินใจ":
      return "border-t-yellow-500";
    case "ปิดการขายเรียบร้อย":
      return "border-t-green-500";
    case "ยกเลิกการทดลองเรียน":
      return "border-t-pink-500";
    case "ปิดการขายไม่สำเร็จ":
      return "border-t-red-500";
    case "ทดลองแล้วลูกค้าไม่สนใจ":
      return "border-t-gray-500";
    case "ยกเลิกทดลองเรียนแต่ให้ครู":
      return "border-t-purple-500";
    case "ลูกค้าไม่สนใจ (รอปรึกษาและตัดจากที่กัพ)":
      return "border-t-stone-500";
    default:
      return "border-t-muted";
  }
}
